import { Box, Grid, Typography } from "@mui/material";
import { IconBtn, useTheme } from "@cellectenergy/cellect-react-components";
import { Card, CardSlider, CardSliderInner } from "./InfoBoxes.styles";
import Image from "next/image";
import { useState } from "react";
//  import CellectAddIcon from "./selectors/addIcon";
// import CellectLessIcon from "./selectors/lessIcon";
import { useTranslation } from "react-i18next";
import dynamic from "next/dynamic";
const AddIcon = dynamic(() => import("@mui/icons-material/Add"), { ssr: false });
const HorizontalRuleSharpIcon = dynamic(() => import("@mui/icons-material/HorizontalRuleSharp"), { ssr: false });

const InfoBoxes = () => {
  const theme = useTheme();
  const { t } = useTranslation("global");

  const cards = [
    {
      id: "userCentric",
      title: `${t("about.infoBoxes.userCentric.title")}`,
      description: `${t("about.infoBoxes.userCentric.description")}`,
    },
    {
      id: "accessible",
      title: `${t("about.infoBoxes.accessible.title")}`,
      description: `${t("about.infoBoxes.accessible.description")}`,
    },
    {
      id: "reliable",
      title: `${t("about.infoBoxes.reliable.title")}`,
      description: `${t("about.infoBoxes.reliable.description")}`,
    },
    {
      id: "scientific",
      title: `${t("about.infoBoxes.scientific.title")}`,
      description: `${t("about.infoBoxes.scientific.description")}`,
    },
  ];

  const [selected, setSelected] = useState<string | null>(null);

  return (
    <Box
      maxWidth={"1440px"}
      margin={{ lg: "0 auto 1.5rem auto" }}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: { xs: "2.5rem 0", md: "2.5rem 0", lg: "3.25rem 2rem " },
        gap: { xs: 3, md: 4 },
        backgroundColor:
          theme.palette.common.corporateColors.primary.midNightBlue,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          textAlign: "left",
          alignItems: "left",
          paddingLeft: {
            xs: "1rem",
            lg: 0,
          },
        }}
      >
        <Grid container display={"flex"} justifyContent={"left"} gap={3}>
          <Grid item xs={12} md={9} lg={8} textAlign="left">
            <Typography
              variant="display-small"
              color={theme.palette.common.corporateColors.primary.white}
              fontWeight={500}
            >
              {t("about.infoBoxes.title")}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <CardSlider>
        <div className="">
          <CardSliderInner>
            {cards.map((card, index) => (
              <Card
                key={index}
                selected={selected === card.title.split("-")[0]}
                onClick={() => {
                  setSelected(
                    selected === card.title.split("-")[0]
                      ? null
                      : card.title.split("-")[0]
                  );
                }}
              >
                <Box
                  sx={{
                    display:
                      selected === card.title.split("-")[0] ? "none" : "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <Typography
                    variant="title-large"
                    color={
                      theme.palette.common.corporateColors.secondary.turquoise
                    }
                    fontWeight={500}
                    sx={{ mb: 2 }}
                  >
                    {card.title}
                  </Typography>
                  <Image
                    src={`/assets/about/${card.id}.svg`}
                    alt="Your Image"
                    width={100}
                    height={100}
                  />
                  <Box
                    sx={{
                      textAlign: "right",
                      padding: 0,
                    }}
                  >
                    <IconBtn
                      aria-label="button more"
                      sx={{
                        "&:hover": {
                          backgroundColor: "transparent",
                        },
                      }}
                    >
                      <AddIcon
                        fontSize="large"
                        sx={{
                          color:
                            theme.palette.common.corporateColors.secondary
                              .turquoise,
                        }}
                      />
                    </IconBtn>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display:
                      selected === card.title.split("-")[0] ? "flex" : "none",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <Typography
                    variant="title-large"
                    color={
                      theme.palette.common.corporateColors.primary.midNightBlue
                    }
                    fontWeight={500}
                    sx={{ mb: 2 }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    color={
                      theme.palette.common.corporateColors.primary.midNightBlue
                    }
                    variant="body-large"
                  >
                    {card.description}
                  </Typography>
                  <Box
                    sx={{
                      textAlign: "right",
                    }}
                  >
                    <IconBtn
                      aria-label="button less"
                      onClick={() => {
                        setSelected(
                          selected === card.title.split("-")[0]
                            ? null
                            : card.title.split("-")[0]
                        );
                      }}
                    >
                      <HorizontalRuleSharpIcon
                        fontSize="large"
                        sx={{
                          color:
                            theme.palette.common.corporateColors.secondary
                              .turquoise,
                        }}
                      />
                    </IconBtn>
                  </Box>
                </Box>
              </Card>
            ))}
          </CardSliderInner>
        </div>
      </CardSlider>
    </Box>
  );
};

export default InfoBoxes;
